<template>
  <div class="consultar-pedidos-cancelados">
    <g-card
      class="card-consultas-pedido-cancelado"
      margem="20px"
      :expansivel="true"
      :comecaFechado="false"
    >
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Pedidos Cancelados </div>
          <div class="header-icons">
            <g-button
              class="trash-box"
              tipo="cinza"
              altura="35px"
              largura="45px"
              icone="icone_lixo.svg"
              tamanhoIcone="15px"
              somenteIcone
              :sombreado="false"
              v-tooltip="'Limpar filtro'"
              @click="limparFiltro"
            />
            <g-button
              class="buscar-button-header-filtro"
              largura="150px"
              icone="icone_lupa.svg"
              negritoTexto
              tamanhoIcone="15px"
              tamanhoTexto="15px"
              altura="35px"
              gap="10px"
              :sombreado="false"
              @click="Buscar()"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form disabled>
        <div class="cancelados-liquidados-conteudo espacamento-filtros">
          <div class="unidade">
            <div class="unidade-titulo titulo-conteudo-filtros">Unidade</div>
            <PDropDown
              class="unidade-input input-label unidade"
              v-model="formSearch.UnidadeId"
              :options="UnidadeArray"
              optionLabel="nome"
              optionValue="id"
              placeholder="TODAS"
            ></PDropDown>
          </div>

          <div class="representante">
            <div class="cliente-titulo titulo-conteudo-filtros"> Cliente </div>
            <cliente-dropdown
              class="cliente-input input-label"
              v-model="formSearch.ClienteId"
              @change="ativaClienteAgrupador"
              :representanteId="this.$store.state.representanteSelecionadoId"
              :empresaId="formSearch.UnidadeId"
            />
          </div>

          <div class="cliente">
            <div class="numero-solicitacao-titulo titulo-conteudo-filtros"> Número da solicitação </div>
            <PInputText
              class="numero-solicitacao-input input-label"
              placeholder="Insira o Nº da solicitação"
              v-model="formSearch.NumeroSolicitacao"
            />
          </div>

          <div class="numero-solicitacao">
            <div class="numero-pedido-titulo titulo-conteudo-filtros"> Número do pedido </div>
            <PInputText
              class="numero-pedido-input input-label"
              placeholder="Insira o N° do pedido"
              v-model="formSearch.NumeroPedido"
            ></PInputText>
          </div>

          <div class="numero-pedido">
            <div class="tipo-pedido-titulo titulo-conteudo-filtros"> Tipo do Pedido </div>
            <PDropDown
              class="tipo-pedido-input input-label"
              placeholder="Selecione"
              v-model="formSearch.TipoPedido"
              :options="TipoPedidoArray"
              optionLabel="text"
              optionValue="value"
            ></PDropDown>
          </div>

          <div class="numero-parcela">
            <div class="numero-notaFiscal-titulo titulo-conteudo-filtros"> Número da nota fiscal </div>
            <PInputText
            class="numero-notaFiscal-input input-label"
            placeholder="Insira o N° da nota fiscal"
              v-model="formSearch.NumeroNotaFiscal"
              ></PInputText>
          </div>
          
          <div class="numero-notaFiscal">
            <div class="codigo-produto-titulo titulo-conteudo-filtros"> Produto </div>
              <PDropDown
              class="nome-produto-input input-label"
              v-model="formSearch.NomeProduto"
              placeholder="Insira o nome do produto"
              optionLabel="labelProduto"
              optionValue="produtoId"
              @filter="getProduto($event.value)"
              :filter="true"
              :options="ProdutoArray"
              />
            </div>
            
            <div class="tipo-pedido">
            <div class="numero-parcela-titulo titulo-conteudo-filtros"> Número da parcela </div>
            <PInputText
              class="numero-parcela-input input-label"
              placeholder="Insira o N° da parcela"
              v-model="formSearch.NumeroParcela"
            ></PInputText>
          </div>

          <div class="nome-produto">
            <div class="nome-produtoNovo-titulo titulo-conteudo-filtros"> Produto Novo </div>
            <PDropDown
              class="nome-produtoNovo-input input-label"
              placeholder="Insira o nome do produto novo"
              :filterFields="['labelProduto']"
              :filter="true"
              optionLabel="labelProduto"
              optionValue="produtoId"
              :options="OrcamentoProdutoArray"
              emptyMessage="Pesquise o produto desejado"
              @filter="buscarProdutoNovo($event.value)"
              v-model="formSearch.NomeProdutoNovo"
            ></PDropDown>

          </div>
          <div class="nome-produtoNovo">
            <div class="periodo-titulo titulo-conteudo-filtros"> No período entre </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                  class="periodo-inicio input-label"
                  placeholderinput="Início"
                  alturainput="45px"
                  largurainput="100%"
                  tamanhobotao="35px"
                  invertido
                  :dataPassadas = "true"
                  v-model="formSearch.DataInicio"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                  class="periodo-termino input-label"
                  placeholderinput="Término"
                  alturainput="45px"
                  largurainput="100%"
                  tamanhobotao="35px"
                  :dataPassadas = "true"
                  invertido
                  v-model="formSearch.DataTermino"
                ></g-date-input>
              </div>
            </div>
          </div>

          <div class="periodo">
            <div class="parametros-titulo titulo-conteudo-filtros"> Outros Parâmetros </div>
            <div class="parametros-checkboxes">
              <div class="consultar-dados checkbox">
                <PCheckBox :disabled="ClienteAgrupadorAtiva" :binary="true" id="consultar-dados" value="consultar-dados" class="checkbox-consultas" v-model="formSearch.DadosClienteAgrupador"></PCheckBox>
                <label class="consultarDados label-checkbox" for="consultar-dados"> Consultar dados do cliente agrupador </label>
            </div>

          </div>

          <div class="parametros">
            <!-- <div class="componentes-expandidos checkbox">
                <PCheckBox id="componentes-expandidos" value="componentes-expandidos" class="checkbox-componentes" v-model="formSearch.ComponentesExpandidos"></PCheckBox>
                <label class="componentesExpandidos label-checkbox" for="componentes-expandidos"> Trazer os componentes expandidos? </label>
              </div> -->
            </div>
          </div>
        </div>

        <div class="buscar-button-filtro">
          <g-button
          class="buscar-button"
          largura="300px"
          icone="icone_lupa.svg"
          negritoTexto
          tamanhoIcone="15px"
          tamanhoTexto="15px"
          altura="35px"
          gap="10px"
          :sombreado="false"
          @click="Buscar()"
          >
          BUSCAR
          </g-button>
        </div>
      </g-form>
    </g-card>

    <!-- Card Nenhuma Informação -->
    <g-card :expansivel="false" :temCabecalho="false" class="card-resultado">
      <div v-if="pt1" class="">
        <img
          class="icone-global-imagemfundo"
          src="@/assets/imgs/Ilustracao_erro.svg"
        />
        <div class="texto-padrao-imagemfundo">
          Verifique os filtros e clique em buscar para exibir os resultados
        </div>
      </div>
      <div v-else-if="!pt1">
        <g-data-table
          ref="grid"
          TextoVazio="Nenhum Pedido Encontrado"
          Titulo="Pedidos Cancelados"
          altura="auto"
          :colunas="Colunas"
          :valores="PedidosCanceladosLiquidadosArray"
          v-model:expandedRowGroups="PedidosCanceladosLiquidadosArray"
          :Paginacao="true"
          :NumeroLinhas="100"
          :FiltrosEspecificos="true"
          :Filtros="Filtro"
          :numeroBotoesAcao="4"
          :NotaFiscal="true"
          :Imprimivel="true"
          v-on:OnNotaFiscal="notasFiscaisRota"
          TextNotaFiscal="Notas fiscais do pedido"
          v-on:duploClickLinha="detalhesPedido"
          :campoAgrupador="'empresaCliente'"
          :campoExibicaoGrupo="'empresaCliente'"
          v-on:clickImprimir="abrirPDF"
          TextImprimir="Abrir PDF"
        >
        <!-- <template #expansivel="slotProps">
            <g-data-table
              TextoVazio="Nenhum Componente Encontrado"
              Titulo="Componente"
              altura="auto"
              :valores="slotProps.linha.data.componenteLCPedidoArray"
              :colunas="ColunasSubGridComponente"
              :NumeroLinhas="2"
              :Editavel= "false"
              :Imprimivel= "false"
              :rowEditor="false"
              :checkprancheta = "false"
              :esconderColunaFrozen = "true"
              :esconderHeader = "true"
              :FiltrosEspecificos = "false"
              :FiltroGeral = "false"
              :Paginacao="false"
              dataKey="PedidoParcelaComponenteId"
            >
            </g-data-table>
          </template> -->
        </g-data-table>
      </div>
    </g-card>

    <g-pdf :pdfFloat="false" :NovaGuia="true" :executar="executarvisualizacao">
      <div class="render" v-if="renderiza">
        <PedidoEmAndamentoPDF 
          :tituloDetalhes="false" 
          v-on:termino="gerarPdf" 
          :pedidoSelecionado="PedidoId" 
        />
      </div>
    </g-pdf>
  </div>
</template>

<script>
import CanceladosLiquidados from "./CanceladosLiquidados.js";
export default CanceladosLiquidados;
</script>

<style scoped>
:deep(.p-inputtext){
  width: 100%;
}

.input-label{
  margin-bottom: 15px;
  width: 100%;
}

.codigo-nome-produto {
  width: 100%;
}

.checkbox {
  display: flex;
  padding-top: 3px;
  padding-bottom: 3px;
}

.label-checkbox {
  color: #8A8A8A;
  text-align: left;
  font-size: 15px;
  font-family: 'MontSerrat';
  margin-left: 5px;
}

td, th {
  border: 1px solid #e6e6e6;
  text-align: center;
  padding: 10px 40px;
}

.codigo-nome-produto {
    width: 100%;
    display: grid;
    grid-template-columns: 30% auto;
    grid-template-rows: auto;
    grid-column-gap: 20px;
    align-items: flex-end;
    align-self: flex-start;
  }

@media (min-width: 310px) {
  .buscar-button-filtro {
    display: flex;
    justify-content: center;
    align-items: self-end;
  }

  .cancelados-liquidados-conteudo {
    display: flex;
    flex-direction: column;
    margin: 20px 0;
  }
  .periodo-inicio { grid-area: 1 / 1 / 2 / 2; }
  .periodo-termino { grid-area: 1 / 3 / 2 / 4; }

  .input-label {
    width: 100%;
  }
}

@media (min-width: 368px) {
}

@media (min-width: 600px) {
  .cancelados-liquidados-conteudo {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(7, auto);
    grid-column-gap: 20px;
  }

  .unidade { grid-area: 1 / 1 / 2 / 2; }
  .representante { grid-area: 1 / 2 / 2 / 3; }
  .cliente { grid-area: 2 / 1 / 3 / 2; }
  .numero-solicitacao { grid-area: 2 / 2 / 3 / 3; }
  .numero-pedido { grid-area: 3 / 1 / 4 / 2; }
  .tipo-pedido { grid-area: 3 / 2 / 4 / 3; }
  .numero-parcela { grid-area: 4 / 1 / 5 / 2; }
  .numero-notaFiscal { grid-area: 4 / 2 / 5 / 3; }
  .codigo-nome-produto { grid-area: 5 / 1 / 6 / 2; }
  .nome-produtoNovo { grid-area: 5 / 2 / 6 / 3; }
  .data { grid-area: 6 / 1 / 7 / 2; }
  .periodo { grid-area: 6 / 1 / 7 / 2;  }
  .parametros { grid-area: 7 / 1 / 8 / 3; }

  .parametros-checkboxes {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
  }

  .buscar-button-filtro {
    display: none;
  }
}

@media (min-width: 801px) {
.cancelados-liquidados-conteudo {
  margin: 20px 20px 0 20px;
}
}

@media (min-width: 1025px) {
  .cancelados-liquidados-conteudo {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(5, auto);
  }

  .cliente { grid-area: 1 / 3 / 2 / 4; }
  .numero-solicitacao { grid-area: 2 / 1 / 3 / 2; }
  .numero-pedido { grid-area: 2 / 2 / 3 / 3; }
  .tipo-pedido { grid-area: 2 / 3 / 3 / 4; }
  .numero-parcela { grid-area: 3 / 1 / 4 / 2; }
  .numero-notaFiscal { grid-area: 3 / 2 / 4 / 3; }
  .codigo-nome-produto { grid-area: 3 / 3 / 4 / 4; }
  .nome-produtoNovo { grid-area: 4 / 1 / 5 / 2; }
  .periodo { grid-area: 4 / 2 / 5 / 3; }
  .parametros { grid-area: 5 / 1 / 6 / 4; }
}

@media (min-width: 1281px) {
}

@media (min-width: 1500px) {
  .cancelados-liquidados-conteudo {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(4, auto);
  }

  .numero-solicitacao { grid-area: 1 / 4 / 2 / 5; }
  .numero-pedido { grid-area: 2 / 1 / 3 / 2; }
  .tipo-pedido { grid-area: 2 / 2 / 3 / 3; }
  .numero-parcela { grid-area: 2 / 3 / 3 / 4; }
  .numero-notaFiscal { grid-area: 2 / 4 / 3 / 5; }
  .codigo-nome-produto { grid-area: 3 / 1 / 4 / 2; }
  .nome-produtoNovo { grid-area: 3 / 2 / 4 / 3; }
  .data { grid-area: 3 / 3 / 4 / 4; }
  .periodo { grid-area: 3 / 3 / 4 / 4; }
  .parametros { grid-area: 4 / 1 / 5 / 3; }
}

@media (min-width: 1900px) {

}
</style>
